export default "__VITE_ASSET___3XktO10__"